<template>
  <div>
    <div class="m-b-10">
      <h4 class="workplatform-title m-t-10 m-b-20">反馈素材下载</h4>
      <Row :gutter="8">
        <i-col span="16">
          <Button
            type="primary"
            size="small"
            long
            :loading="loading"
            @click="onCreateTask"
            >创建下载任务</Button
          >
        </i-col>
         <i-col span="8">
          <Button
            type="primary"
            size="small"
            long
            @click="getDownloadList"
          >刷新列表</Button>
        </i-col>
      </Row>
    </div>
    <Table
      stripe
      size="small"
      :data="downloadTaskList"
      :columns="columns"
    ></Table>
    <!-- <Button
      type="primary"
      long
      :loading="loading"
      @click="onBatchDonwload"
    >{{loading?'数据处理中，请耐心等待...':'批量下载反馈素材'}}</Button> -->
  </div>
</template>

<script>
import {
  createDownloadTaskAttach,
  getpptreportlist
} from '@/api/msp/msppreport'
// utils
// import { downloadFileRequest } from '@/utils/download'
export default {
  props: {
    mspTaskId: [Number]
  },
  data () {
    return {
      loading: false,
      uniqueFlag: '',
      timeOut: null,
      downloadTaskList: [],
      columns: [
        { title: '创建时间', key: 'createTime' },
        { title: '状态', key: 'statusText' },
        {
          title: '操作',
          render: (h, params) => {
            return h('div', [
              params.row.status === 3
                ? h(
                  'a',
                  {
                    style: { marginRight: '5px' },
                    on: {
                      click: () => {
                        location.href = params.row.fileKey
                      }
                    }
                  },
                  '下载'
                )
                : null
            ])
          }
        }
      ]
    }
  },
  computed: {
    orderInfo () {
      return this.$store.state.installSetting.orderInfo
    },
    demandStartDate () {
      return this.$store.state.installSetting.demandStartDate
    },
    demandEndDate () {
      return this.$store.state.installSetting.demandEndDate
    }
  },

  methods: {
    async getDownloadList () {
      const postData = {
        taskId: this.mspTaskId,
        fileType: 4
      }
      const res = await getpptreportlist(postData)
      if (res && !res.errcode) {
        this.downloadTaskList = res
      }
    },
    async onCreateTask () {
      this.loading = true
      const postData = { taskId: this.mspTaskId }
      const res = await createDownloadTaskAttach(postData).finally(() => {
        this.loading = false
      })
      if (res && res.success) {
        this.$Notice.success({ desc: '操作成功' })
        this.getDownloadList()
      }
    }
    // onBatchDonwload () {
    //   if (!this.mspTaskId) {
    //     return false
    //   }
    //   this.loading = true
    //   this.onRequestDownload()
    //   // 5分钟超时处理
    //   this.timeOut = setTimeout(() => {
    //     // clearInterval(timer)
    //     this.loading = false
    //     this.$Notice.error({ desc: '数据处理时间过长' })
    //   }, 1000 * 60 * 5)
    // },
    // onRequestDownload () {
    //   const postData = {
    //     taskId: this.mspTaskId,
    //     uniqueFlag: this.uniqueFlag
    //   }

    //   downLoadTaskAttach(postData).then((res) => {
    //     if (res && !res.errcode) {
    //       this.uniqueFlag = res.uniqueFlag
    //       // 文件生成完成
    //       if (res.status === 2) {
    //         clearTimeout(this.timeOut)
    //         this.loading = false
    //         // 执行下载文件流程
    //         this.onDownloadFile()
    //       } else {
    //         setTimeout(() => {
    //           this.onRequestDownload()
    //         }, 2500)
    //       }
    //     } else {
    //       this.loading = false
    //       clearTimeout(this.timeOut)
    //     }
    //   })
    // },
    // onDownloadFile () {
    //   const query = {
    //     uniqueFlag: this.uniqueFlag
    //   }

    //   downloadFileRequest(
    //     process.env.VUE_APP_API_URL_V2 +
    //       '/ooh-msp/v2/msppreport/getTaskAttachZip',
    //     query,
    //     `${this.orderInfo.advertiserName}(${this.demandStartDate}至${this.demandEndDate}).zip`
    //   )
    // }
  },
  watch: {
    mspTaskId: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val > 0) {
          this.getDownloadList()
        }
      }
    }
  }
}
</script>
